import * as Yup from 'yup'
import {
  SHOW_COUNTRIES,
  SHOW_OPTION,
  SHOW_OPTION_COUNTRIES,
  SHOW_OPTION_REGIONS,
  SHOW_OPTION_WORLDWIDE,
  SHOW_REGIONS
} from '../../../../ReusableFormFields/GeolocationsFields/fields'
import { geolocationsValidation } from '../../../../../features/validations/gelolocations'

// STATUS
export const STATUS = 'status'
export const regionsValidation = {
  [SHOW_REGIONS]: Yup.array().when(SHOW_OPTION, {
    is: SHOW_OPTION_REGIONS,
    then: () => Yup.array().min(1, 'Please select at least one option')
  })
}

export const googleGeolocationValidationSchema = Yup.object({
  ...geolocationsValidation,
  ...regionsValidation
})

export const formatGoogleLocationsToBe = (locations, locationValue) => {
  return locations.map(({ [locationValue]: resourceName }) => ({
    location: {
      geo_target_constant: resourceName
    }
  }))
}

export const transformLocationsToBE = values => {
  switch (values[SHOW_OPTION]) {
    case SHOW_OPTION_COUNTRIES:
      return formatGoogleLocationsToBe(values[SHOW_COUNTRIES], 'resourceName')
    case SHOW_OPTION_REGIONS:
      return formatGoogleLocationsToBe(values[SHOW_REGIONS], 'resource_name')
    case SHOW_OPTION_WORLDWIDE:
    default:
      return []
  }
}
